import { ConversationStatus } from 'generated-graphql/types';
import { completedStatuses } from '../constants';

export const isConversationCompleted = (status: ConversationStatus) =>
  completedStatuses.includes(status);
